import ChrismasPng from '@/public/chrismas.png';
import IconPng from '@/public/icon.png';
import LogoCutSvg from '@/public/logoCut.svg';
import LogoSvg from '@/public/logo.svg';
import NextSvg from '@/public/next.svg';
import SpiritoryBannerPng from '@/public/spiritory_banner.png';
import ThirteenSvg from '@/public/thirteen.svg';
import VercelSvg from '@/public/vercel.svg';

export {
  ChrismasPng,
  IconPng,
  LogoCutSvg,
  LogoSvg,
  NextSvg,
  SpiritoryBannerPng,
  ThirteenSvg,
  VercelSvg,
};
